export enum Role {
  User = "USER",
  Researcher = "RESEARCHER",
  TeamManager = "TEAM_MANAGER",
  Admin = "ADMIN"
}
